/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Payor from './Payor/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/DueAmounts/Content/DueNow/Content"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let categoryTypeValueData = fromData.useDataValue({ viewPath,
context: 'category',
path: 'type',
})
let constantData = 'due_30_days'
let aggregateData = fromAggregate.equals(categoryTypeValueData, constantData)
let categoryTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'category',
path: 'type',
})
let constantData1 = 'due_60_days'
let aggregateData1 = fromAggregate.equals(categoryTypeValueData1, constantData1)
let categoryTypeValueData2 = fromData.useDataValue({ viewPath,
context: 'category',
path: 'type',
})
let constantData2 = 'due_90_days'
let aggregateData2 = fromAggregate.equals(categoryTypeValueData2, constantData2)
let categoryTypeValueData3 = fromData.useDataValue({ viewPath,
context: 'category',
path: 'type',
})
let categoryTypeValueData4 = fromData.useDataValue({ viewPath,
context: 'category',
path: 'type',
})
let constantData3 = 'future_due'
let aggregateData3 = fromAggregate.equals(categoryTypeValueData3, categoryTypeValueData4, constantData3)
let constantData4 = 'total_due'
let aggregateData4 = fromAggregate.equals(constantData4)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let paymentAccountDueAmountsTreatmentNameValueData = fromData.useDataValue({ viewPath,
context: 'payment_account_due_amounts',
path: 'treatment.name',
})
let constantData5 = 'All treatments'
let aggregateData5 = fromAggregate.any(paymentAccountDueAmountsTreatmentNameValueData, constantData5)
let categoryPaymentAccountsValueData = fromData.useDataValue({ viewPath,
context: 'category',
path: 'payment_accounts',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite,'--bc-2-Z1Yf8zk': dtColorsNeutral200,'--btlr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-8-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-9-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-10-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-11-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={dtColorsNeutral500}
 text={aggregateData ? "Due >30d" : aggregateData1 ? "Due >60d" : aggregateData2 ? "Due >90d" : aggregateData3 ? "Future due" : aggregateData4 ? "Total due" : "Due now"}
 data={aggregateData ? "category.type" : aggregateData1 ? "category.type" : aggregateData2 ? "category.type" : aggregateData3 ? "'total_due'" : "category.type"}
 data={aggregateData ? "category.type" : aggregateData1 ? "category.type" : aggregateData2 ? "category.type" : aggregateData3 ? "'total_due'" : "'due_30_days'"}
 aggregate={aggregateData1 ? "/Data/aggregate.js equals" : aggregateData2 ? "/Data/aggregate.js equals" : aggregateData3 ? "/Data/aggregate.js equals" : aggregateData4 ? "/Data/aggregate.js equals" : "/Data/aggregate.js equals"}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="payment_account_due_amounts.treatment.name"
 data="'All treatments'"
 aggregate="/Data/aggregate.js any"
 text={aggregateData5}
 weight="medium"
/>
<div
  data-testid="Content.List"
  data-view-path={viewPath}
 style={{'--g-11-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(categoryPaymentAccountsValueData) && categoryPaymentAccountsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="payor"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Payor(${item?.id ?? item?._id ?? index})`}
      >
<Payor
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Payor(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</div>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }